import api from "./api";

const fetchMarketRates = async (params = {}) => {
  const response = await api.get("/admin-rates/market/fetch", { params });
  return response.data;
};

const compareWithMarket = async (params = {}) => {
  const response = await api.get("/admin-rates/market/compare", {
    params: {
      ...params,
      branchCode: params.branchCode, // Explicitly include branchCode
    },
  });
  return response.data;
};

const syncFromMarket = async (syncData) => {
  const response = await api.post("/admin-rates/market/sync", syncData);
  return response.data;
};

const getMarketHistory = async (params) => {
  const response = await api.get("/admin-rates/market/history", { params });
  return response.data;
};

const marketRateService = {
  fetchMarketRates,
  compareWithMarket,
  syncFromMarket,
  getMarketHistory,
};

export default marketRateService;
